import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setInventoryPopOverTitle: {
    description: 'Set inventory pop-over title',
    defaultMessage: 'Set On Hand Qty',
    id: 'pGZeiQ',
  },
  setInventoryPopoverCancel: {
    description: 'Set inventory pop-over cancel button',
    defaultMessage: 'Cancel',
    id: '/uE0CX',
  },
  setInventoryRemoveButton: {
    description: 'Set inventory pop-over add button',
    defaultMessage: 'Set On Hand Quantity',
    id: 'CspQ3a',
  },
});
